// Утилиты форматирования и общие карты подписей модуля разработки продукции.

export const money = (v: number | null | undefined, currency = "RUB"): string => {
  if (v == null) return "—";
  // Валюта может прийти невалидной (напр. "—" при пустом составе) — Intl тогда
  // бросает исключение и роняет экран. Форматтер обязан быть неубиваемым.
  const cur = /^[A-Za-z]{3}$/.test(currency) ? currency.toUpperCase() : "RUB";
  try {
    return new Intl.NumberFormat("ru-RU", {
      style: "currency",
      currency: cur,
      maximumFractionDigits: 2,
    }).format(v);
  } catch {
    return `${new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 2 }).format(v)} ₽`;
  }
};

export const num = (v: number | null | undefined): string =>
  v == null ? "—" : new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 4 }).format(v);

export const fmtDate = (s: string | null | undefined): string =>
  !s ? "—" : new Date(s).toLocaleDateString("ru-RU");

// Цвета стадий (Tailwind, dark-aware) — для бейджей на доске/карточке.
export const STAGE_STYLES: Record<string, string> = {
  idea: "bg-muted text-foreground/80",
  in_progress: "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300",
  review: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
  approved: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300",
  tech_card: "bg-teal-100 text-teal-700 dark:bg-teal-900/40 dark:text-teal-300",
  in_1c: "bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300",
  launched: "bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300",
  archived: "bg-muted text-muted-foreground",
};

export const PEREDEL_STYLES: Record<string, string> = {
  PF: "bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300",
  PGP: "bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-300",
  GP: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300",
};

// Человеческие ярлыки трёх переделов (прячем жаргон ПФ/ПГП/ГП от продакта).
export const PEREDEL_LABEL: Record<string, string> = {
  GP: "Готовый продукт",
  PGP: "Флакон в сборе",
  PF: "Формула",
};
export const PEREDEL_HINT: Record<string, string> = {
  GP: "то, что продаём: флакон + упаковка",
  PGP: "флакон с этикеткой и розливом",
  PF: "сваренный состав / рецептура",
};

// Единый разбор ошибки API → человекочитаемая строка для toast.
export const apiErr = (e: unknown, fallback = "Ошибка"): string => {
  const maybe = e as { response?: { data?: { detail?: string } } };
  return maybe.response?.data?.detail ?? fallback;
};
